(() => {
  if (window.customProductGridScriptReady) return;
  window.customProductGridScriptReady = true;

  const scrollBehavior = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  window.slideCustomGrid = (sectionId, direction) => {
    const container = document.getElementById('panels-container-' + sectionId);
    const grid = container?.querySelector('.custom-tab-panel.is-active .custom-grid-' + sectionId);
    if (!grid) return;
    const card = grid.querySelector('.custom-card');
    const scrollStep = card ? (card.offsetWidth + 40) * 1.5 : 350;
    grid.scrollBy({ left: direction * scrollStep, behavior: scrollBehavior() });
  };

  window.updateCustomCardImage = select => {
    const imgUrl = select.options[select.selectedIndex]?.dataset.img;
    const image = select.closest('.custom-card')?.querySelector('.custom-card-image');
    if (!imgUrl || !image) return;
    const url = new URL(imgUrl, document.baseURI);
    image.srcset = [240, 360, 480, 600].map(width => {
      url.searchParams.set('width', width);
      return `${url} ${width}w`;
    }).join(', ');
    image.src = imgUrl;
  };

  function initGrid(section) {
    if (section.dataset.customGridReady) return;
    const filterTrack = section.querySelector('.custom-filter-scroll-track');
    const panels = section.querySelectorAll('.custom-tab-panel');
    if (!filterTrack || !panels.length) return;
    section.dataset.customGridReady = 'true';

    const stickyBackArea = section.querySelector('.custom-sticky-back-area');
    const backBtn = section.querySelector('.custom-back-btn');
    const filterBtns = Array.from(filterTrack.querySelectorAll('.custom-filter-btn'));
    let currentParent = '';
    const historyStack = [];

    function activatePanel(target) {
      panels.forEach(panel => {
        if (panel.id === target) {
          const template = panel.querySelector('template');
          if (template) {
            template.replaceWith(template.content);
          }
        }
        panel.classList.toggle('is-active', panel.id === target);
      });
    }

    function renderCategoryLevel(parentName) {
      let visibleBtns = parentName
        ? filterBtns.filter(btn => btn.dataset.parent === parentName.toLowerCase())
        : filterBtns.filter(btn => !btn.dataset.parent);

      if (!visibleBtns.length) {
        visibleBtns = filterBtns;
        if (stickyBackArea) stickyBackArea.style.display = 'none';
      } else if (stickyBackArea) {
        stickyBackArea.style.display = parentName ? 'flex' : 'none';
      }

      filterBtns.forEach(btn => {
        btn.classList.remove('active');
        btn.style.display = visibleBtns.includes(btn) ? 'inline-block' : 'none';
      });

      if (visibleBtns.length) {
        const firstBtn = visibleBtns[0];
        activatePanel(firstBtn.dataset.target);
        const isLeafLevel = !visibleBtns.some(btn =>
          filterBtns.some(child => child.dataset.parent === btn.dataset.tag)
        );
        if (isLeafLevel && parentName) firstBtn.classList.add('active');
      }
      filterTrack.scrollTo({ left: 0, behavior: scrollBehavior() });
    }

    filterTrack.addEventListener('click', event => {
      const btn = event.target.closest('.custom-filter-btn');
      if (!btn || !filterTrack.contains(btn)) return;
      const hasChildren = filterBtns.some(child => child.dataset.parent === btn.dataset.tag);
      if (hasChildren) {
        historyStack.push(currentParent);
        currentParent = btn.dataset.tag;
        renderCategoryLevel(currentParent);
      } else {
        filterBtns.forEach(item => item.classList.remove('active'));
        btn.classList.add('active');
        activatePanel(btn.dataset.target);
      }
    });

    backBtn?.addEventListener('click', () => {
      currentParent = historyStack.length ? historyStack.pop() : '';
      renderCategoryLevel(currentParent);
    });

    renderCategoryLevel('');
  }

  function initAll(root = document) {
    if (root.matches?.('[data-custom-product-grid]')) initGrid(root);
    root.querySelectorAll('[data-custom-product-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));

  if (!window.customProductGridCartHandlerReady) {
    window.customProductGridCartHandlerReady = true;
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!form.classList.contains('custom-card-form') ||
          !form.closest('[data-custom-product-grid]')) return;
      event.preventDefault();
      const button = form.querySelector('.custom-card-btn');
      if (button.disabled) return;
      const originalText = button.innerText;
      button.innerText = 'ADDING...';
      button.classList.add('is-loading');
      button.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then(response => {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(data => {
          button.innerText = 'ADDED!';
          button.classList.replace('is-loading', 'is-added');
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          setTimeout(() => {
            const cartIcon = document.querySelector('#cart-icon-bubble') ||
              document.querySelector('a[href="/cart"]') ||
              document.querySelector('.header__icon--cart');
            if (cartIcon) cartIcon.click();
            else window.location.href = '/cart';
            button.innerText = originalText;
            button.classList.remove('is-added');
            button.disabled = false;
          }, 400);
        })
        .catch(() => {
          button.innerText = 'ERROR';
          button.classList.remove('is-loading');
          setTimeout(() => {
            button.innerText = originalText;
            button.disabled = false;
          }, 2000);
        });
    });
  }
})();
